export default "/assets/website/images/b2blogo.svg?1f557d52e572bd20db7dc9cfcb45e118";